export enum Resources {
  Appointments = 'engage/appointments',
  AppointmentTypes = 'engage/appointmentTypes',
  CaseForms = 'engage/caseForms',
  CaseLetters = 'engage/caseLetters',
  Cases = 'engage/cases',
  CaseStatuses = 'engage/caseStatuses',
  CaseTags = 'engage/cases/:id/tags',
  CaseTypes = 'engage/caseTypes',
  CaseTypeObjectLinks = 'engage/caseTypes/:id/links',
  CaseTypeTags = 'engage/caseTypes/:id/tags',
  EngageMetrics = 'engage/metrics',
  FormContents = 'engage/formContents',
  Forms = 'engage/forms',
  Letters = 'engage/letters',
  PublicCaseForms = 'public/engage/caseForms',
  PublicForm = 'public/engage/form',
  NylasOrganizationGrants = 'engage/nylas/organizationGrants',
  NylasAdminGrants = 'engage/nylas/adminGrants',
  TranslateText = 'engage/translate/text',
  TranslateTexts = 'engage/translate/texts',
  TranslateDetect = 'engage/translate/detect',
}
